/**
 * SyncOperation 仓库（PRD §10.2 / §12）。
 *
 * 离线同步队列条目；payload 字段是元数据（操作类型/目标 ID），不加密。
 */

import {
  PROLOGUE_DB_NAME,
  PROLOGUE_DB_VERSION,
  PROLOGUE_STORES,
  get,
  list as listAll,
  put,
  remove as removeOne,
} from './db';
import type { SyncOperation } from '../../model/types';

const STORE = 'syncOperations';

export async function saveSyncOperation(op: SyncOperation): Promise<string> {
  return put(PROLOGUE_DB_NAME, PROLOGUE_DB_VERSION, PROLOGUE_STORES, STORE, op);
}

export async function loadSyncOperation(id: string): Promise<SyncOperation | undefined> {
  return get<SyncOperation>(PROLOGUE_DB_NAME, PROLOGUE_DB_VERSION, PROLOGUE_STORES, STORE, id);
}

export async function listSyncOperations(): Promise<SyncOperation[]> {
  return listAll<SyncOperation>(PROLOGUE_DB_NAME, PROLOGUE_DB_VERSION, PROLOGUE_STORES, STORE);
}

export async function removeSyncOperation(id: string): Promise<void> {
  return removeOne(PROLOGUE_DB_NAME, PROLOGUE_DB_VERSION, PROLOGUE_STORES, STORE, id);
}
